<div class="form-grid">
  <sh-field
    class="field-wide"
    label="shared.terms.description"
    [required]="true"
    [error]="
      descriptionTouched && !isDescriptionValid
        ? ('notes.error.fieldDescription' | translate)
        : null
    "
  >
    <sh-input
      [(value)]="note.description"
      (focusout)="descriptionTouched = true"
    ></sh-input>
  </sh-field>
  <sh-field
    class="field-wide"
    label="shared.terms.remarks"
    [required]="true"
    [error]="
      remarksTouched && !isRemarksValid
        ? ('notes.error.fieldRemarks' | translate)
        : null
    "
  >
    <sh-textarea
      [(value)]="note.remarks"
      [rows]="5"
      (focusout)="remarksTouched = true"
    ></sh-textarea>
  </sh-field>
  <sh-field class="field-wide">
    <sh-checkbox label="notes.pinned" [(value)]="note.pinned"></sh-checkbox>
  </sh-field>
</div>

<sh-dialog-footer>
  <sh-button
    label="shared.terms.cancel"
    variant="text"
    (click)="dialogRef.cancel()"
  ></sh-button>
  <sh-button
    label="shared.terms.ok"
    [disabled]="!isValid"
    (click)="ok()"
  ></sh-button>
</sh-dialog-footer>
